
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/social-sidebar.kpa`,
      template: `<div class="social-sidebar box-shadow">
        <div class="wrapper">
            <a href="tel:+4922194085999">
                <i class="fa-solid fa-phone"></i>
            </a>

            <a href="mailto:hallo@fase2.de?subject=Anfrage">
                <i class="fa-solid fa-envelope"></i>
            </a>

            <a href="https://www.instagram.com/fase2_nrw/" aria-label="FASE2 auf Instagram">
                <i class="fa-brands fa-instagram"></i>
            </a>
        </div>
    </div>`,
      style: `social-sidebar {
  display: none;
  position: fixed;
  z-index: 10;
}
social-sidebar .social-sidebar {
  background-color: #ffffff;
  border: 3px solid #64c16c;
  border-radius: 8px;
}
social-sidebar .social-sidebar .wrapper {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
social-sidebar .social-sidebar .wrapper a {
  width: 32px;
  height: 32px;
  color: #2c4143;
  text-align: center;
  line-height: 32px;
}
social-sidebar .social-sidebar .wrapper a:hover {
  color: #64c16c;
}

social-sidebar.right {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
social-sidebar.right .social-sidebar {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-width: 0;
  padding: 4px 0;
}
social-sidebar.right .social-sidebar .wrapper {
  flex-flow: column nowrap;
}

social-sidebar.left {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
social-sidebar.left .social-sidebar {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-width: 0;
  padding: 4px 0;
}
social-sidebar.left .social-sidebar .wrapper {
  flex-flow: column nowrap;
}

social-sidebar.top {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
social-sidebar.top .social-sidebar {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-top-width: 0;
  padding: 0 4px;
}
social-sidebar.top .social-sidebar .wrapper {
  flex-flow: row nowrap;
}

social-sidebar.bottom {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
social-sidebar.bottom .social-sidebar {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-width: 0;
  padding: 0 4px;
}
social-sidebar.bottom .social-sidebar .wrapper {
  flex-flow: row nowrap;
}

@media (min-width: 993px) {
  social-sidebar {
    display: block;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  